import { render, staticRenderFns } from "./micDetector.vue?vue&type=template&id=34746e9e&scoped=true"
import script from "./micDetector.vue?vue&type=script&lang=js"
export * from "./micDetector.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=34746e9e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34746e9e",
  null
  
)

export default component.exports